/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { notification } from 'antd';
import axios from 'axios';
import queryString from 'query-string';
import { AuthenticationServices } from '../services/authentication.service';

export const axiosClient = axios.create({
  baseURL: `${window?.env?.NX_API_BASE_URL || process.env.NX_API_BASE_URL}`,
  headers: {
    'content-type': 'application/json',
  },
  paramsSerializer: (params) => queryString.stringify(params),
});

axiosClient.interceptors.request.use(async (config: any) => {
  const isAuthenticated = JSON.parse(
    localStorage.getItem('user_login') || '{}'
  );
  const token = isAuthenticated?.token;
  config.headers.TimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  let header = {
    ...headersCommon,
  }
  if (config.headers['Content-Type']) {
    header = {
      ...header,
      'Content-Type': config.headers['Content-Type']
    };
  }
  config.headers = {
    ...config.headers,
    ...header,
  };
  
  return config;
});

axiosClient.interceptors.response.use(
  (response) => {
    if (response && (response.data || response.data === 0)) {
      return response.data;
    }
    return response;
  },
  (error) => {
    if (error.response?.status === 400) {
      notification.error({ message: error?.message });
    }

    if (error.response?.status === 401) {
      AuthenticationServices.logout();
      if (window) {
        window?.location.replace('/login');
      }
    }
    throw error;
  }
);

export const headersCommon = {
  'Content-Type': 'application/json',
  'Access-Control-Allow-Origin': '*',
  'Access-Control-Allow-Headers': '*',
  'Access-Control-Allow-Credentials': 'true',
}